import axios, { AxiosError } from 'axios'
import apiClient from '@services/api.client'
import { acquireAccessToken } from '@utils/authConfig'
import { ILoggingRequestDTO } from '@services/dtos/logging.dto'
import { ILoggingRepository } from '@services/types'

export class LoggingRepository implements ILoggingRepository {
	private resource: string

	constructor() {
		this.resource = 'logging'
	}

	postLog = async (logDTO: ILoggingRequestDTO): Promise<void> => {
		try {
			await apiClient.post('', logDTO, {
				params: {
					resource: this.resource
				},
				headers: {
					token: await acquireAccessToken()
				}
			})
		} catch (error: unknown | Error | AxiosError) {
			if (axios.isAxiosError(error)) {
				throw new Error('Error while posting frontend log: ' + error.message)
			}

			throw error
		}
	}
}